export default __webpack_public_path__ + "static/media/2.3.1.6fbf8580.jpg";